import { render, staticRenderFns } from "./CurriculumList.vue?vue&type=template&id=0bfd5f62&scoped=true&lang=pug"
import script from "./CurriculumList.vue?vue&type=script&lang=js"
export * from "./CurriculumList.vue?vue&type=script&lang=js"
import style0 from "./CurriculumList.vue?vue&type=style&index=0&id=0bfd5f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd5f62",
  null
  
)

export default component.exports